import styled from 'styled-components';
import { Color } from '../../config/Color';

export const Container = styled.div`
  padding: ${({ theme }) => `${theme.spacing._10px} 0`};
  margin: ${({ theme }) => `${theme.spacing._20px} 0`};
  border-radius: ${({ theme }) => theme.spacing._22px};
`;

export const LightContainer = styled(Container)`
  background: ${Color.surface.muted};
`;

export const PaddedLightContainer = styled(LightContainer)`
  padding: ${({ theme }) => theme.spacing._16px};
  text-align: left;
`;

type PaddedContainerProp = { center?: boolean; borderRadius?: boolean };
export const PaddedAccentContainer = styled(Container)<PaddedContainerProp>`
  padding: ${({ theme }) => theme.spacing._22px};
  margin: ${({ borderRadius }) => (borderRadius ? '20px 0' : '0 0 20px')};
  text-align: ${({ center }) => (center ? 'center' : 'left')};
  position: relative;
  background: ${Color.surface.accent};
  border-radius: ${({ borderRadius }) => (borderRadius ? '22px' : '0px')};
`;
